import { NgModule } from "@angular/core";
import { SearchModule } from "./price-search/search.module";

@NgModule({
    exports: [SearchModule],
    imports: [SearchModule],
})
export class PriceModule {}